import { render, staticRenderFns } from "./BrandMedia.vue?vue&type=template&id=42fb810d"
import script from "./BrandMedia.vue?vue&type=script&lang=js"
export * from "./BrandMedia.vue?vue&type=script&lang=js"
import style0 from "./BrandMedia.vue?vue&type=style&index=0&id=42fb810d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports